import { Avatar, Typography } from "@mui/material";
import { generateAvatar } from "app/utils/avatar";
import React from "react";
import { useSelector } from "react-redux";
import TopUserTransmissionChart from "../user_progress_analytic/chart/TopUserTransmissionChart";

const TopUserTransmission = ({ getStyles, getChartOptions }) => {
  const { topUserTransmissionProgressData } = useSelector(
    (state) => state.userActivityLog
  );

  return (
    <>
      <div className={getStyles().topUserTransmissionContainer}>
        {topUserTransmissionProgressData?.dailyReportCount?.map(
          (reportCount) => (
            <div
              key={reportCount.name}
              className={getStyles().topUserTransmissionChart}
            >
              <div className="d-flex justify-between">
                <div className="d-flex">
                  <Avatar sx={{ width: 50, height: 50, fontSize: "0.875rem" }}>
                    {generateAvatar(reportCount.name)}
                  </Avatar>
                  <div style={{ marginLeft: "10px" }}>
                    <h4>{reportCount.name}</h4>
                    <Typography variant="body2" noWrap>
                      {reportCount.email}
                    </Typography>
                  </div>
                </div>

                <div style={{ textAlign: "right", marginRight: "8px" }}>
                  Total<h3>{reportCount.count}</h3>
                </div>
              </div>
              <div
                className="d-flex"
                style={{ marginTop: "15px", height: "250px" }}
              >
                <TopUserTransmissionChart
                  maxCount={reportCount.maxCount}
                  chartData={{
                    labels: topUserTransmissionProgressData.labels,
                    datasets: [
                      {
                        label: "Processed Transmissions",
                        data: reportCount.chartData,
                        borderColor: "#94BA33",
                        backgroundColor: "#94BA33",
                      },
                    ],
                  }}
                  getChartOptions={getChartOptions}
                />
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default TopUserTransmission;
